import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginForm from './Login';
import Dashboard from './Dashboard';
import Upload from './Upload';
import Upload_new from './upload_new';
import Upload_new_radio from './Upload_new_radio.js';


import Preparequestion  from './Preparequestion';
import Preparequestionlist from './Preparequestionlist';
import PreparequestionType from './Preparequestiontype.js';
import AddQuestionType from './AddQuestionType.js';


import ProfileForm from './ProfileForm';
import Question from './Question';
import Vivalist from './Vivalist';
import Employee from './Employee';
import ChangePassword from './ChangePassword';
import EditEmployee from "./EditEmployee.js";
import Reports from "./Reports.js";
import Reports1 from "./Reports1.js";
import NewReports from "./NewReports.js";
import UploadQuestion from "./UploadQuestion.js";
import NewPromotionReports from "./NewPromotionReports.js";
import UploadWrittenQuestion from  "./UploadWrittenQuestion.js";
import ResetPassword from "./ResetPassword";
import GetPdf from "./GetPdf";
import GetPdfAll from "./GetPdfAll";
import Pdf from "./Pdf.js";




// import ChangePassword1 from './ChangePassword1';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
         <Route path="/Dashboard" element={<Dashboard />} /> 
         <Route path="/Upload" element={<Upload />}/>
         <Route path="/Upload_New" element={<Upload_new />}/>
         <Route path="/Upload_New_Radio" element={<Upload_new_radio />}/>
         <Route path="/Preparequestion" element={<Preparequestion />} />
         <Route path="/Preparequestionlist" element={<Preparequestionlist />} />
         <Route path="/PreparequestionType" element={<PreparequestionType />} />
         <Route path="/AddQuestionType" element={<AddQuestionType />} />
         <Route path="/ProfileForm" element={<ProfileForm />} />
         <Route path="/Question" element={<Question />} />
         <Route path="/Vivalist" element={<Vivalist />} />
         <Route path="/ChangePassword" element={<ChangePassword />} /> 
         <Route path="/Employee" element={<Employee />} /> 
         <Route path="/reports" element={<Reports />} /> 
         <Route path="/reports1" element={<Reports1 />} /> 
         <Route path='/edit_employee/:id' element={<EditEmployee />} />
         <Route path="/new_reports" element={<NewReports />} /> 
         <Route path="/upload_question" element={<UploadQuestion />} /> 
         <Route path="/upload_written_question" element={<UploadWrittenQuestion />} /> 
         <Route path="/new_promotion_reports" element={<NewPromotionReports />} /> 
         <Route path="/reset-password" element={<ResetPassword />} />
         <Route path="/getPdf" element={<GetPdf />} />
         <Route path="/getPdfAll" element={<GetPdfAll />} />
         <Route path="/Pdf" element={<Pdf />} />
        {/* <Route path="/change_password1" element={<ChangePassword1 />} />  */}
         


        {/* Uncomment and use these routes as needed */}
        {/* <Route path="/change_password1" element={<ChangePassword1 />} /> */}
        {/* <Route path="/Dashboard" element={<Dashboard1 />} /> 
        <Route path="/upload" element={<Upload />}/> */}
        
      </Routes>
    </Router>
  );
};

export default App; // Ensure there is a default export
